import React from 'react';

import { BareSailing } from '../../../shared/types/sailing';
import { getCrewSailings } from '../../lib/api/crewSchedule';
import {
  addDaysToUTCDate,
  DEFAULT_HOUR_FORMAT,
  DEFAULT_TIMESTR_FORMAT,
  getLocaleUTCDateString,
  isSameDayUTC,
} from '../../../shared/lib/time';

import './Sailings.scss';
import { TextButton, InlineIcon } from '@spark-labs/avocado-ui';
import { getDayLocation, getDayFirstArrival, getDayLastDeparture } from '@go-shared/lib/sailing';

const DEFAULT_DISPLAYED_DAYS = 15;

export interface SailingsProps {
  date: Date;
  onHomeButtonClick: () => void;
  staffTemplateId: string;
}

export interface SailingsState {
  displayedDays: number;
  sailings: BareSailing[];
}

function getSailingDates(sailing: BareSailing): string {
  let startDate = sailing.days[0].date;
  let endDate = sailing.days[sailing.days.length - 1].date;
  return `${getLocaleUTCDateString(startDate)} - ${getLocaleUTCDateString(endDate)}`;
}

export default class Sailings extends React.Component<SailingsProps, SailingsState> {
  public readonly state: SailingsState = {
    sailings: [],
    displayedDays: DEFAULT_DISPLAYED_DAYS,
  };

  constructor(props: SailingsProps) {
    super(props);
  }

  public componentDidMount() {
    return this.loadSailings();
  }

  public componentDidUpdate(prevProps: SailingsProps) {
    if (prevProps.date !== this.props.date) {
      return this.loadSailings();
    }
  }

  public render() {
    return (
      <div className="bg-blue-darkest flex-grow overflow-y-auto text-xs">
        <div className="flex justify-end items-center px-2 py-1 bg-blue-darkest">
          <TextButton onClick={this.props.onHomeButtonClick}>
            <InlineIcon className="w-6 h-6 text-white" name={'home'} />
          </TextButton>
        </div>
        {this.state.sailings.map(sailing => (
          <div key={sailing._id} className="text-blue-darker w-full py-2 px-3">
            <table className="SailingTable bg-grey-light w-full">
              <tbody>
                <tr>
                  <td rowSpan={2} className="font-bold italic text-base">
                    {sailing.name}
                  </td>
                  <td colSpan={3} className="bg-blue-darkest text-white">
                    {getSailingDates(sailing)}
                  </td>
                </tr>
                <tr className="bg-blue-darkest text-grey-light">
                  <td>Port</td>
                  <td>Arrive</td>
                  <td>Depart</td>
                </tr>
                {sailing.days.map(day => (
                  <tr
                    key={day._id}
                    className={`SailingTableDay ${
                      isSameDayUTC(day.date, this.props.date) ? 'bg-green' : ''
                    }`}
                  >
                    <td style={{ width: '18%' }}>
                      Day <span className="font-bold">{day.name}</span>
                    </td>
                    {/* FIXME: Only supports a single port! */}
                    <td style={{ width: '38%' }}>{getDayLocation(day)}</td>
                    <td style={{ width: '22%' }}>
                      {getDayFirstArrival(day, DEFAULT_HOUR_FORMAT, DEFAULT_TIMESTR_FORMAT)}
                    </td>
                    <td style={{ width: '22%' }}>
                      {getDayLastDeparture(day, DEFAULT_HOUR_FORMAT, DEFAULT_TIMESTR_FORMAT)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ))}
      </div>
    );
  }

  private async loadSailings() {
    const endDate = addDaysToUTCDate(new Date(this.props.date), this.state.displayedDays);

    let sailings = await getCrewSailings(this.props.staffTemplateId, this.props.date, endDate);

    this.setState({ sailings });
  }
}
